import React, { useEffect, useState } from "react";
import { Menu, X, MapPin } from "lucide-react";
import { Button } from "./ui/button";
import { NAV_LINKS } from "../mock";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#f6f1e7]/85 backdrop-blur-md border-b border-black/5 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 group">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-emerald-800 to-emerald-950 grid place-items-center shadow-sm group-hover:rotate-6 transition-transform">
            <MapPin className="w-5 h-5 text-emerald-100" strokeWidth={2.4} />
          </div>
          <span className={`font-display text-xl font-semibold ${scrolled ? "text-emerald-950" : "text-white drop-shadow"}`}>
            Splitara
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`text-sm font-medium hover:opacity-70 transition ${
                scrolled ? "text-emerald-950" : "text-white/90 drop-shadow"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#contact"
            className={`text-sm font-medium ${scrolled ? "text-emerald-950" : "text-white/90"} hover:opacity-70`}
          >
            Log in
          </a>
          <Button
            asChild
            className="rounded-full bg-emerald-950 hover:bg-emerald-900 text-emerald-50 px-5"
          >
            <a href="#get-app">Get the app</a>
          </Button>
        </div>

        <button
          className={`md:hidden ${scrolled ? "text-emerald-950" : "text-white"}`}
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden mx-6 mt-3 rounded-2xl bg-white shadow-lg border border-black/5 p-4">
          <div className="flex flex-col gap-2">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2 rounded-lg text-emerald-950 hover:bg-[#f6f1e7]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#get-app"
              onClick={() => setOpen(false)}
              className="mt-2 text-center rounded-full bg-emerald-950 text-emerald-50 px-5 py-2 font-medium"
            >
              Get the app
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
